import { SVGProps } from 'react';

const Slice = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11 16.586V19a1 1 0 0 1-1 1H2L18.37 3.63a2.121 2.121 0 1 1 3 3l-9.663 9.663a1 1 0 0 1-.707.293m0 0a1 1 0 0 1-.707-.293L8 14"
    />
  </svg>
);
export default Slice;
